export default "__VITE_ASSET__XasD$Uga__"